import React, { useState } from 'react';
import '../modules/Module.css';

const AgencyListElement = ({ agency, users, onExpand }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getStateName = (stateCode) => {
        const states = {
            13: 'Georgia',
            1: 'Alabama',
            5: 'Arkansas',
            // Add more states as needed
        };
        return states[stateCode] || `State ${stateCode}`;
    };

    const handleToggleExpand = () => {
        if (!isExpanded) {
            onExpand(); // Fetch users when expanding
        }
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="agency-list-element">
            <div className="agency-header" onClick={handleToggleExpand}>
                <div className="agency-info">
                    <div className="agency-name-section">
                        <h3 className="agency-name">{agency.agency_name}</h3>
                        <span className="agency-number">({agency.agency_number})</span>
                    </div>
                    <div className="agency-details">
                        <span className="agency-state">{getStateName(agency.agency_state)}</span>
                        <span className="agency-email">{agency.agency_email}</span>
                        <span className="agency-subscription">{agency.subscription_type}</span>
                    </div>
                </div>
                <div className="agency-stats">
                    <div className="stat-item">
                        <span className="stat-label">Reports:</span>
                        <span className="stat-value">{agency.reports_processed?.toLocaleString() || '0'}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-label">ePCR:</span>
                        <span className="stat-value">{agency.ePCR_provider || 'N/A'}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-label">Users:</span>
                        <span className="stat-value">{agency.user_count || 0}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-label">Medics:</span>
                        <span className="stat-value">{agency.medic_count || 0}</span>
                    </div>
                    <div className="stat-item">
                        <span className="stat-label">Configured:</span>
                        <span className="stat-value">
                            <i className={`fa-solid ${agency.settings_json ? 'fa-check' : 'fa-times'}`} 
                               style={{ color: agency.settings_json ? '#28a745' : '#dc3545' }}></i>
                        </span>
                    </div>
                </div>
                <button className="expand-button">
                    <i className={`fa-solid fa-angle-${isExpanded ? 'up' : 'down'}`}></i>
                </button>
            </div>
            
            {isExpanded && (
                <div className="users-section">
                    <div className="users-header">
                        <h4>Agency Details</h4>
                    </div>
                    <div className="agency-details-expanded">
                        <div className="detail-row">
                            <div className="detail-item">
                                <span className="detail-label">Registered:</span>
                                <span className="detail-value">{formatDate(agency.registered_timestamp)}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Timezone:</span>
                                <span className="detail-value">{agency.agency_timezone || 'N/A'}</span>
                            </div>
                        </div>
                        <div className="detail-row">
                            <div className="detail-item">
                                <span className="detail-label">Data Horizon:</span>
                                <span className="detail-value">{agency.data_horizon ? `${agency.data_horizon} months` : 'N/A'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Subscription:</span>
                                <span className="detail-value">{agency.subscription_type || 'N/A'}</span>
                            </div>
                        </div>
                        <div className="detail-row">
                            <div className="detail-item">
                                <span className="detail-label">Reports Processed:</span>
                                <span className="detail-value">{agency.reports_processed?.toLocaleString() || '0'}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">ePCR Provider:</span>
                                <span className="detail-value">{agency.ePCR_provider || 'N/A'}</span>
                            </div>
                        </div>
                        <div className="detail-row">
                            <div className="detail-item">
                                <span className="detail-label">Total Users:</span>
                                <span className="detail-value">{agency.user_count || 0}</span>
                            </div>
                            <div className="detail-item">
                                <span className="detail-label">Total Medics:</span>
                                <span className="detail-value">{agency.medic_count || 0}</span>
                            </div>
                        </div>
                    </div>
                    
                    {users.length > 0 && (
                        <div className="users-list-section">
                            <div className="users-list-header">
                                <h4>Users ({users.length})</h4>
                            </div>
                            <div className="users-list">
                                {users.map((user) => (
                                    <div key={user.uid} className="user-item">
                                        <div className="user-info">
                                            <div className="user-name">{user.account_owner_name}</div>
                                            <div className="user-email">{user.email}</div>
                                            <div className="user-role">{user.user_role_description || 'No role specified'}</div>
                                        </div>
                                        <div className="user-dates">
                                            <div className="date-item">
                                                <span className="date-label">Registered:</span>
                                                <span className="date-value">{formatDate(user.registered_timestamp)}</span>
                                            </div>
                                            <div className="date-item">
                                                <span className="date-label">Last Login:</span>
                                                <span className="date-value">{formatDate(user.last_login_timestamp)}</span>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default AgencyListElement; 